module.exports = __webpack_public_path__ + "img/11.c5d7fdb6.webp";